/* TLB sticky offset (v1.6).
   Measures where the sticky site header actually ends and publishes it as --tlb-sticky-top on <html>.
   Used by the Shop page category bar (top) and by in-page anchors (scroll-margin-top).
   Recomputed when the header resizes (ResizeObserver), on viewport resize, after fonts load, and on scroll
   (rAF-throttled) so the announcement bar showing/hiding or a header that shrinks/hides on scroll is handled.
   Also gives same-page anchor links (data-tlb-smooth or #shop-the-look style links) a smooth scroll that
   lands below the header. */
(function () {
  if (window.__tlbSticky) return; window.__tlbSticky = true;
  var de = document.documentElement, last = null, queued = false;
  function headerEl() { return document.querySelector('.header-section') || document.querySelector('#header-component'); }
  function measure() {
    queued = false;
    var hs = headerEl(), v = 0;
    if (hs) {
      var cs = getComputedStyle(hs);
      var h = document.querySelector('#header-component');
      var hidden = h && h.getAttribute('data-sticky-state') === 'idle';
      if ((cs.position === 'sticky' || cs.position === 'fixed') && !hidden) {
        var t = parseFloat(cs.top); if (isNaN(t)) t = 0;
        v = Math.max(0, t + hs.getBoundingClientRect().height);
      }
    }
    v = Math.round(v * 100) / 100;
    if (v !== last) { last = v; de.style.setProperty('--tlb-sticky-top', v + 'px'); }
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(measure); } }
  measure();
  var hs = headerEl();
  if (hs && 'ResizeObserver' in window) new ResizeObserver(queue).observe(hs);
  var h = document.querySelector('#header-component');
  if (h && 'MutationObserver' in window) new MutationObserver(queue).observe(h, { attributes: true, attributeFilter: ['data-sticky-state', 'sticky'] });
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('scroll', queue, { passive: true, capture: true });
  window.addEventListener('load', queue);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);

  /* Smooth same-page anchor scrolling that respects scroll-margin-top, whichever element scrolls
     (Horizon scrolls .page-wrapper on desktop and the window on mobile). */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-tlb-smooth]');
    if (!a || ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
    if (!u.hash || u.pathname !== location.pathname) return;
    var target = document.getElementById(decodeURIComponent(u.hash.slice(1)));
    if (!target) return;
    ev.preventDefault(); measure();
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', u.hash);
  });
})();
